












import {Component, Prop, Vue} from 'vue-property-decorator';
import {ActiveInject} from "@/support/reactive"

/**
 * @status stable
 * @published 4.0.0
 * @changelog 4.0.0 Published.
 * @changelog 4.4.0 Added toolbar slot, stacking mode support, and adjustments for use in narrow section areas.
 * @changelog 4.5.0 Isolate CSS.
 * @changelog 4.9.1 Add top margin as a default.
 */
@Component
export default class JdsPageSectionHeading extends Vue {
    @ActiveInject({from: 'jds.page.section-heading.small', default: false}) smallContext!: boolean
    @ActiveInject({from: 'jds.page-layout.stack', default: false}) stacking!: boolean
}
